import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  recvCode: {
    name: "recvCode",
    label: "Receiving Code",
    type: "text",
    errorMsg: "Receiving code is required",
    maxLength: 20,
    disabled: true,
  },
  extRecvCode: {
    name: "extRecvCode",
    label: "Existing Receiving Code",
    type: "text",
  },
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer code is required.",
    required: true,
    disabled: true,
  },
  vendorCode: {
    name: "vendorCode",
    label: "Vendor Code",
    type: "select",
    errorMsg: "Vendor code is required.",
    required: true,
    editable: false,
  },
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse code is required.",
    required: true,
  },
  recvType: {
    name: "recvType",
    label: "Receiving Type",
    type: "text",
    disabled: true,
  },
  asnCode: {
    name: "asnCode",
    label: "ASN Code",
    type: "select",
    editable: false,
  },
  poNumber: {
    name: "poNumber",
    label: "PO Number",
    type: "text",
  },
  extPoNumber: {
    name: "extPoNumber",
    label: "Existing Po Number",
    type: "text",
  },
  collectionOrderNo: {
    name: "collectionOrderNo",
    label: "Collection Order No",
    type: "select",
    //required: true,
    editable: false,
  },
  dateReceived: {
    name: "dateReceived",
    label: "Date Received",
    type: "date",
    required: true,
    errorMsg: "Date Received is required.",
  },
  registrationID: {
    name: "registrationID",
    label: "Registration ID",
    type: "text",
  },
  sellerCompany: {
    name: "sellerCompany",
    label: "Consignee Name",
    type: "text",
    required: true,
    errorMsg: "Consignee Name is required.",
  },
  sellerAddress1: {
    name: "sellerAddress1",
    label: "Address 1",
    type: "text",
  },
  sellerAddress2: {
    name: "sellerAddress2",
    label: "Address 2",
    type: "text",
  },
  sellerPostcode: {
    name: "sellerPostcode",
    label: "Postcode",
    type: "text",
  },
  sellerCity: {
    name: "sellerCity",
    label: "City",
    type: "text",
  },
  sellerState: {
    name: "sellerState",
    label: "State",
    type: "text",
  },
  sellerCountry: {
    name: "sellerCountry",
    label: "Country",
    type: "select",
  },
  sellerPhoneNo: {
    name: "sellerPhoneNo",
    label: "Phone No",
    type: "text",
  },
  sellerFaxNo: {
    name: "sellerFaxNo",
    label: "Fax No",
    type: "text",
  },
  truckNo: {
    name: "truckNo",
    label: "Truck No",
    type: "text",
  },
  containerNo: {
    name: "containerNo",
    label: "Container No",
    type: "text",
  },
  containerType: {
    name: "containerType",
    label: "Container Type",
    type: "text",
  },
  chargeable: {
    name: "chargeable",
    label: "Chargeable",
    type: "switch",
    default: false,
    required: true,
  },
  manualPutaway: {
    name: "manualPutaway",
    label: "Manual Putaway",
    type: "switch",
    default: false,
    required: true,
  },
  remark: {
    name: "remark",
    label: "Remark",
    type: "text",
  },
  status: {
    name: "status",
    label: "Status",
    type: "text",
    disabled: true,
  },
  vDONo: {
    name: "vDONo",
    label: "DO No (RF Scanning)",
    type: "select",
    style: {
      "& .MuiInputLabel-root": {
        color: "blue !important",
      },
    },
  },
};

const {
  recvCode,
  extRecvCode,
  vendorCode,
  customerCode,
  warehouseCode,
  recvType,
  asnCode,
  collectionOrderNo,
  dateReceived,
  registrationID,
  sellerCompany,
  sellerAddress1,
  sellerAddress2,
  sellerPostcode,
  sellerCity,
  sellerState,
  sellerCountry,
  sellerPhoneNo,
  sellerFaxNo,
  truckNo,
  containerNo,
  containerType,
  chargeable,
  manualPutaway,
  remark,
  status,
  vDONo,
} = formField;

// export const headerRender=[[recvCode, status],
// [dateReceived, recvType],
// [vendorCode, customerCode],
// [collectionOrderNo,warehouseCode],
// [registrationID, truckNo],
// [containerNo, containerType],
// [chargeable, manualPutaway],
// [remark],
// [
//   {
//     //if u want to wrap field
//     type: "fieldset",
//     label: "Consignee",
//     fieldsetRender: [
//       [sellerCompany],
//       [sellerAddress1],
//       [sellerAddress2],
//       [sellerPostcode, sellerCity],
//       [sellerState, sellerCountry],
//       [sellerPhoneNo, sellerFaxNo],
//     ],
//   },
// ]]
export const headerRender = [
  [recvCode, recvType, customerCode, status],
  [dateReceived, vendorCode, collectionOrderNo, warehouseCode],
  [containerNo, containerType,registrationID, truckNo],
  [chargeable, manualPutaway,remark,vDONo],
  [
    {
      type: "fieldset",
      label: "Consignee",
      fieldsetRender: [
        [sellerCompany],
        [sellerAddress1, sellerAddress2,sellerPostcode, sellerCity],
        [sellerState, sellerCountry,sellerPhoneNo, sellerFaxNo],
      ],
    },
  ],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [recvCode.name]: Yup.string().nullable(),
  [extRecvCode.name]: Yup.string().nullable().max(20),
  // [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
  [vendorCode.name]: Yup.string().nullable().max(20).required(vendorCode.errorMsg),
  [warehouseCode.name]: Yup.string().nullable().max(20).required(warehouseCode.errorMsg),
  [recvType.name]: Yup.string().nullable(),
  // [asnCode.name]: Yup.string().nullable().max(20),
  // [poNumber.name]: Yup.string().nullable().max(20),
  // [extPoNumber.name]: Yup.string().nullable().max(20),
  [collectionOrderNo.name]: Yup.string().nullable().max(20),
  [dateReceived.name]: Yup.string().nullable().required(dateReceived.errorMsg),
  [registrationID.name]: Yup.string().nullable().max(50),
  [sellerCompany.name]: Yup.string().nullable().max(100).required(sellerCompany.errorMsg),
  [sellerAddress1.name]: Yup.string().nullable().max(200),
  [sellerAddress2.name]: Yup.string().nullable().max(200),
  [sellerPostcode.name]: Yup.string().nullable().max(10),
  [sellerCity.name]: Yup.string().nullable().max(100),
  [sellerState.name]: Yup.string().nullable().max(100),
  [sellerCountry.name]: Yup.string().nullable().max(100),
  [sellerPhoneNo.name]: Yup.string().nullable().max(20),
  [sellerFaxNo.name]: Yup.string().nullable().max(20),
  [truckNo.name]: Yup.string().nullable().max(20),
  [containerNo.name]: Yup.string().nullable().max(20),
  [containerType.name]: Yup.string().nullable().max(50),
  [chargeable.name]: Yup.string().nullable().max(20),
  [manualPutaway.name]: Yup.string().nullable().max(20),
  [remark.name]: Yup.string().nullable().max(300),
});
